import { render, staticRenderFns } from "./OptionsQuestion.vue?vue&type=template&id=891178a0&scoped=true&"
import script from "./OptionsQuestion.vue?vue&type=script&lang=js&"
export * from "./OptionsQuestion.vue?vue&type=script&lang=js&"
import style0 from "./OptionsQuestion.vue?vue&type=style&index=0&id=891178a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891178a0",
  null
  
)

export default component.exports